import { supabase } from '../lib/supabase';
import { EventReferee } from '../types/models';

export const getEventReferees = async (eventId: string): Promise<EventReferee[]> => {
  const { data, error } = await supabase
    .from('event_referees')
    .select(`
      assignment_id,
      event_id,
      referee_id,
      role,
      created_at,
      referee:referees(
        referee_id,
        first_name,
        last_name,
        first_name_tamil,
        last_name_tamil,
        email,
        phone
      )
    `)
    .eq('event_id', eventId)
    .order('role');
    
  if (error) {
    throw new Error(error.message);
  }
  
  return data || [];
};

export const assignReferee = async (assignment: Omit<EventReferee, 'assignment_id' | 'created_at' | 'referee'>): Promise<EventReferee> => {
  const { data, error } = await supabase
    .from('event_referees')
    .insert([assignment])
    .select(`
      assignment_id,
      event_id,
      referee_id,
      role,
      created_at,
      referee:referees(
        referee_id,
        first_name,
        last_name,
        first_name_tamil,
        last_name_tamil,
        email,
        phone
      )
    `)
    .single();
    
  if (error) {
    throw new Error(error.message);
  }
  
  return data;
};

export const removeRefereeAssignment = async (assignmentId: string): Promise<void> => {
  const { error } = await supabase
    .from('event_referees')
    .delete()
    .eq('assignment_id', assignmentId);
    
  if (error) {
    throw new Error(error.message);
  }
};